var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 5,
    viewBox: "0 0 5 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.93771 0.240204H4.70437L3.02938 2.15479L5 4.75958H3.45708L2.24875 3.17958L0.865833 4.75958H0.09875L1.89042 2.71166L0 0.240412H1.58208L2.67437 1.68458L3.93771 0.240204ZM3.66875 4.30083H4.09354L1.35125 0.674996H0.895417L3.66875 4.30083Z",
    fill: "#156DD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterVector);
export default __webpack_public_path__ + "static/media/twitterVector.514d5ed99816feef3b0fefc6f93b1ed2.svg";
export { ForwardRef as ReactComponent };